import { render } from "./show.vue?vue&type=template&id=7247dfdd&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=7247dfdd&scoped=true&lang=css"
import "./show.vue?vue&type=style&index=1&id=7247dfdd&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7247dfdd"]])

export default __exports__